$(function() {
    window.widget.selectionEmitter.on('selection', element => {
        const aboutBox = $('.about-box');
        const urnwallModal = $('.js-urnwall-modal');
        const marker = $('.js-mark-selection');
        const routePlanner = $('.js-get-route');

        if (!element) {
            aboutBox.removeClass('about-box-visible');
            if (!urnwallFromList) {
                urnwallModal.addClass('visible-print');
            }
            delete window.selectedGraveId;
            return;
        }

        $.ajax({
            url: `${window.api}/graves/${element.id}`,
            type: 'GET',
            async: false,
            headers: {
                Authorization: 'Bearer ' + window.iFrameToken,
            },
            success: function(response) {
                let graveName;
                const { photos, parcel = '', deads, fancyName } = response;
                const row = response.row === null ? '' : '/' + response.row;
                const pos = response.pos === null ? '' : '-' + response.pos;

                const selectedElement = response;

                if (!selectedElement.routes) {
                    routePlanner.addClass('grave-action-disabled');
                } else if (routePlanner.hasClass('grave-action-disabled')) {
                    routePlanner.removeClass('grave-action-disabled');
                }

                if (window.selectedGraveId == selectedElement.id) {
                    aboutBox.removeClass('about-box-visible');
                    urnwallModal.addClass('visible-print');
                    delete window.selectedGraveId;
                    return;
                }

                if (selectedElement.id === window.markedGraveId) {
                    marker.attr('src', 'assets/img/icons/icon-location-marked.svg');
                } else {
                    marker.attr('src', 'assets/img/icons/icon-location.svg');
                }
                if (selectedElement.id === window.routedGraveId) {
                    routePlanner.attr('src', 'assets/img/icons/icon-route-active.svg');
                } else {
                    routePlanner.attr('src', 'assets/img/icons/icon-route.svg');
                }

                window.graveId = selectedElement.id;
                window.selectedGraveId = selectedElement.id;

                const urns = selectedElement.urns;

                if (!urnwallFromList) {
                    if (urns.length) {
                        const tabletView = window.innerWidth >= 672 && window.innerWidth <= 1199;
                        let colsToGet = tabletView ? 2 : getUrnwallCollsByWindowWidth();
                        urnwallModal.removeClass('has-selected');
                        urnwallModal.removeClass('visible-print');
                        createUrnwallSlider(urns, colsToGet, $('.js-urn-slider'));
                        aboutBox.removeClass('about-box-visible');
                    } else {
                        urnwallModal.addClass('visible-print');
                    }
                }

                if (!urns.length) {
                    deads.sort(function(a, b) {
                        const textA = a.name.toUpperCase();
                        const textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });

                    const output = createDeceasedList(deads);
                    $('.js-output-card').html(output.join(''));
                } else if (!urnwallFromList) {
                    $('.js-output-card').empty();
                }

                if (selectedElement && selectedElement.description) {
                    const description = `
                        <div class="grave-description time">
                            <p>${selectedElement.description}</p>
                        </div>`;
                    const jsOutputCard = $('.js-output-card').html();
                    $('.js-output-card').html([description, jsOutputCard]);
                }

                if (fancyName) {
                    graveName = fancyName;
                } else {
                    graveName = parcel + row + pos;
                }

                window.graveyard = selectedElement.graveyardId;

                $('.swiper-title').text('Sírazonosító: ' + graveName);

                if (photos && photos.length !== 0) {
                    createThumbnailAndSlider(
                        photos,
                        $('.js-count-image'),
                        $('.js-modal-slider'),
                        $('.js-open-gallery')
                    );
                } else if (!urnwallFromList) {
                    // no photo for the grave, set it to 0
                    $('.js-count-image').text(0);
                    // clear the background image
                    $('.about-box .img-container').css('background-image', '');
                }

                setFeedbackButtonStatus(
                    urns,
                    deads,
                    $('.js-urnwall-table'),
                    $('#about-box-footer--button'),
                    $('#about-box-footer--cancel')
                );

                $('.ol-zoom-in, .ol-zoom-out, .ol-zoom-extent button').css('right', '24px');
                $('.about-box').addClass('about-box-visible');
                $('.information-tab').addClass('information-tab-visible');

                $('.about-title, .js-urnwall-position').text(graveName);

                $('.search-bar').removeClass('search-bar-active');
                $('.logo').css('z-index', 3);

                $('#about-box-footer--button').show();
                if (!urnwallFromList) {
                    $.loadGraveyard();
                }
                urnwallFromList = false;
            },
        });
    });
});
